export default __webpack_public_path__ + "static/media/airplane-button.d59e0e42.svg";